import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LOGO_IMAGES } from '../../config/imagePaths';
import { POLICIES } from '../../config/policies';
import { colors, fontFamily, fontSizes, fontWeights, radii } from '../../theme/tokens';
import { useIsMobile } from '../../hooks/useMediaQuery';
import LoginForm from './LoginForm';

const POINTS = ['Mandatory books pre-selected', 'Secure Razorpay payment', 'Track every order'];

const CheckIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#9fd0d2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const LoginScreen = () => {
  const [logoError, setLogoError] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleLoginSuccess = () => {
    navigate('/');
  };

  const handleRegisterSuccess = () => {
    navigate('/profile/complete');
  };

  const gutter = isMobile ? 16 : 24;

  return (
    <div
      style={{
        width: '100%', minHeight: '100vh', boxSizing: 'border-box', fontFamily, color: colors.ink,
        background: colors.pageGrey, display: 'flex', flexDirection: 'column',
      }}
    >
      <div style={{ background: colors.white, borderBottom: '1px solid ' + colors.border }}>
        <div
          style={{
            maxWidth: 1200, margin: '0 auto', padding: '0 ' + gutter + 'px', height: isMobile ? 64 : 84,
            boxSizing: 'border-box', display: 'flex', alignItems: 'center',
          }}
        >
          {!logoError ? (
            <img
              src={LOGO_IMAGES.LOCKUP}
              alt="VidyarthiKart - Official book partner"
              style={{ height: isMobile ? 44 : 64, width: 'auto', objectFit: 'contain', display: 'block' }}
              onError={() => setLogoError(true)}
            />
          ) : (
            <span style={{ fontSize: fontSizes.h3, fontWeight: fontWeights.bold, color: colors.navy }}>Vidyarthi Kart</span>
          )}
        </div>
      </div>

      <div
        style={{
          flexGrow: 1, display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'center',
          padding: isMobile ? '24px ' + gutter + 'px' : '56px ' + gutter + 'px', boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            width: '100%', maxWidth: isMobile ? 520 : 1040, display: 'grid',
            gridTemplateColumns: isMobile ? 'minmax(0, 1fr)' : 'repeat(2, minmax(0, 1fr))',
            borderRadius: isMobile ? 22 : radii.hero, overflow: 'hidden', background: colors.white,
            border: '1px solid ' + colors.border, boxShadow: '0 12px 40px rgba(15,27,51,0.10)',
          }}
        >
          {!isMobile && (
            <div
              style={{
                background: colors.navy, color: colors.white, padding: '56px 48px', display: 'flex',
                flexDirection: 'column', gap: 24, justifyContent: 'center',
              }}
            >
              <span
                style={{
                  alignSelf: 'flex-start', padding: '6px 14px', borderRadius: radii.pill,
                  background: colors.navyTint, color: '#dfe7f7', fontSize: fontSizes.small, fontWeight: fontWeights.semibold,
                }}
              >
                Back to school
              </span>
              <h1 style={{ margin: 0, fontSize: 40, lineHeight: 1.12, fontWeight: fontWeights.bold }}>
                Your child's complete book set, delivered home.
              </h1>
              <p style={{ margin: 0, fontSize: fontSizes.bodyLg, lineHeight: 1.6, color: colors.footerText }}>
                Log in with your mobile number to order textbooks, notebooks and stationery for your school in one go.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 8, fontSize: fontSizes.body }}>
                {POINTS.map((p) => (
                  <span key={p} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <CheckIcon />
                    {p}
                  </span>
                ))}
              </div>
            </div>
          )}
          <div style={{ padding: isMobile ? '28px 20px' : '56px 48px', display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: 0 }}>
            <LoginForm onLoginSuccess={handleLoginSuccess} onRegisterSuccess={handleRegisterSuccess} />
          </div>
        </div>
      </div>

      <nav
        aria-label="Policies"
        style={{
          display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: isMobile ? '4px 16px' : '8px 28px',
          padding: '0 ' + gutter + 'px ' + (isMobile ? 24 : 32) + 'px',
        }}
      >
        {POLICIES.map((p) => (
          <Link
            key={p.slug}
            to={p.path}
            style={{
              color: colors.slate, fontSize: fontSizes.small, textDecoration: 'none',
              minHeight: isMobile ? 32 : undefined, display: 'inline-flex', alignItems: 'center',
            }}
          >
            {p.title}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default LoginScreen;
